import React, { useEffect, useState } from "react";
import BorderColorTwoToneIcon from '@mui/icons-material/BorderColorTwoTone';
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import AlternateEmailTwoToneIcon from '@mui/icons-material/AlternateEmailTwoTone';
import WorkTwoToneIcon from '@mui/icons-material/WorkTwoTone';
import MobileFriendlyTwoToneIcon from '@mui/icons-material/MobileFriendlyTwoTone';
import LocationOnTwoToneIcon from '@mui/icons-material/LocationOnTwoTone';
import { NavLink, useHistory, useParams } from "react-router-dom";

const Details = () => {
    const [getuserdata, setUserdata] = useState([]);
    console.log(getuserdata);

    const { id } = useParams("");
    console.log(id);

    const history = useHistory();

    const getdata = async () => {

        const res = await fetch(`https://shivammcrud.herokuapp.com/getuser/${id}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        });

        const data = await res.json();
        console.log(data);

        if (res.status === 422 || !data) {

            console.log("error");
        } else {
            setUserdata(data)
            console.log("get data")
        }
    }

    useEffect(() => {
        getdata();
    }, [])
    const deleteuser = async (id) => {
        const res2 = await fetch(`https://shivammcrud.herokuapp.com/deleteuser/${id}`, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json"
            }
        });

        const deletedata = await res2.json();
        console.log(deletedata);

        if (res2.status === 422 || !deletedata) {
            console.log("error")
        } else {
            console.log("user deleted");  
            history.push("/")
        }
    }

    return (
        <div className="container mt-3">
            <h1 style={{ fontweight: 400 }}>{getuserdata.name}</h1>
            <Card sx={{ maxWidth: 600 }}>
                <CardContent>
                    <div className="add_btn">
                        <NavLink to={`/edit/${getuserdata._id}`}><button className='btn btn-primary mx-2'><BorderColorTwoToneIcon /></button></NavLink>
                        <button className='btn btn-danger' onClick={() => deleteuser(getuserdata._id)}><DeleteTwoToneIcon /></button>
                    </div>
                    <div className="row">
                        <div className="left_view col-lg-6 col-md-6 col-12">
                            <img src="/profile.png" style={{ width: 50 }} alt="profile" />
                            <h3 className="mt-3">Name:<span>{getuserdata.name}</span></h3>
                            <h3 className="mt-3">Age:<span>{getuserdata.age}</span></h3>
                            <p className="mt-3"><AlternateEmailTwoToneIcon />Email: <span>{getuserdata.email}</span></p>
                            <p className="mt-3"><WorkTwoToneIcon />Occupation: <span>{getuserdata.work}</span></p>
                        </div>
                        <div className="right_view col-lg-6 col-md-6 col-12">
                            <p className="mt-5"><MobileFriendlyTwoToneIcon />Mobile:<span>{getuserdata.mobile}</span></p>
                            <p className="mt-3"><LocationOnTwoToneIcon />Location:<span>{getuserdata.add}i</span></p>
                            <p className="mt-3">Description:<span>{getuserdata.desc}</span></p>
                        </div>
                    </div>
                </CardContent>
            </Card>
        </div>
    )
}

export default Details;